import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

interface Product {
  id: number;
  name: string;
  price: string;
  image: string;
  short_description: string;
  category_name: string;
}

const Shop: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const category = searchParams.get('category') || '';

  useEffect(() => {
    setLoading(true);
    fetch('https://fellfell.ir/api/test-full.php?action=api-products')
      .then(res => res.json())
      .then(data => {
        if (data.success && Array.isArray(data.data)) {
          let filtered = data.data;
          if (category) {
            const categoryMap: { [key: string]: string } = {
              'seeds': 'بذر',
              'pesticides': 'سموم',
              'fertilizers': 'کودها',
              'equipment': 'ادوات'
            };
            filtered = data.data.filter((p: any) => p.category_name === categoryMap[category]);
          }
          setProducts(filtered);
        } else {
          setError('خطا در دریافت محصولات');
        }
        setLoading(false);
      })
      .catch(() => {
        setError('خطا در ارتباط با سرور');
        setLoading(false);
      });
  }, [category]);

  if (loading) return <div className="loading">در حال بارگذاری...</div>;
  if (error) return <div className="alert alert-error">{error}</div>;

  return (
    <>
      <div className="page-header">
        <div className="container">
          <h1>فروشگاه</h1>
        </div>
      </div>
      <section style={{ padding: '20px 0' }}>
        <div className="container">
          <div style={{ background: '#fff', padding: '20px', borderRadius: '12px', marginBottom: '30px' }}>
            <h3 style={{ marginBottom: '10px' }}>دسته‌بندی</h3>
            <select
              value={category}
              onChange={(e) => window.location.href = `/shop?category=${e.target.value}`}
              style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }}
            >
              <option value="">همه</option>
              <option value="seeds">بذر</option>
              <option value="pesticides">سموم</option>
              <option value="fertilizers">کودها</option>
              <option value="equipment">ادوات</option>
            </select>
          </div>
          <div className="product-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '25px' }}>
            {products.length > 0 ? (
              products.map(p => (
                <div key={p.id} style={{ background: '#fff', borderRadius: '16px', padding: '20px', boxShadow: '0 4px 20px rgba(0,0,0,0.06)', textAlign: 'center' }}>
                  <img 
                    src={`https://fellfell.ir/uploads/products/${p.image || 'default.jpg'}`} 
                    alt={p.name} 
                    style={{ width: '100%', height: '200px',    aspectRatio: '1/1',        // ← کلید اصلی
 objectFit: 'cover', borderRadius: '12px', marginBottom: '15px' }}
                    onError={(e) => { e.currentTarget.src = 'https://fellfell.ir/assets/images/product-placeholder.jpg'; }}
					  loading="lazy"               // ← اضافه شد برای بهینه‌سازی
  decoding="async"             // ← اضافه شد برای بهینه‌سازی

                  />
                  <h3 style={{ fontSize: '17px', color: '#1e3a1e' }}>{p.name}</h3>
                  <p style={{ fontSize: '13px', color: '#888' }}>{p.short_description}</p>
                  <p style={{ color: '#2E7D32', fontSize: '20px', fontWeight: 'bold', margin: '10px 0' }}>
                    {new Intl.NumberFormat('fa-IR').format(Number(p.price))} تومان
                  </p>
                  <Link to={`/product/${p.id}`} className="btn btn-primary">مشاهده</Link>
                </div>
              ))
            ) : (
              <p>محصولی یافت نشد.</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Shop;